import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { DBDef_PermissionAPI } from '@nu-art/permissions-shared';
export const dispatch_onPermissionAPIChanged = new ThunderDispatcherV3('__onPermissionAPIUpdated');
export class ModuleFE_PermissionAPI_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_PermissionAPI, dispatch_onPermissionAPIChanged);
        this._v1 = {};
    }
}
export const ModuleFE_PermissionAPI = new ModuleFE_PermissionAPI_Class();
//# sourceMappingURL=ModuleFE_PermissionAPI.js.map